import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {trackSpaPageView} from "../lib/spaAnalytics";

export default function AnalyticsRouteObserver() {
  const {pathname} = useLocation();
  useEffect(() => {
    trackSpaPageView({pathname, origin: window.location.origin, title: document.title});
  }, [pathname]);
  return null;
}
